import { defineMessages } from 'react-intl';

export default defineMessages({
  messageBarDismissButtonAriaLabel: {
    id: 'notificationLayout.messageBarDismissButtonAriaLabel',
    defaultMessage: 'Dismiss notification',
  },
});
